export const Info: React.FC = () => {
  return (
    <div className="dqm-tcui-info_container">
      <h1 className="dqm-tcui-info_container__title">Tervetuloa meille!</h1>
    </div>
  );
};
